import store from '../../store';

function checkGuestAndAuthenticated(to, from, next) {
  if (to.meta.guest) {
    return store.getters['auth/authenticated']
      ? next({ name: 'Home' })
      : next();
  }

  return store.getters['auth/authenticated']
    ? next()
    : next({ name: 'Auth-Login' });
}

export default checkGuestAndAuthenticated;
